var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"flex items-center justify-center pt-5 "},[_c('img',{staticClass:"h-full w-full pt-1 rounded-full",attrs:{"src":require("../assets/RasFamilie.png"),"alt":"Workflow"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }